<template>
  <PopupTemplate @close="closeCuponAmigoAsignado()">
    <div>
      <div class="cabecera">¡Ya está todo hecho!</div>
      <p>
        Gracias a tu amigo has conseguido un 10% de descuento en la renovación
        de tu póliza {{ cupon.numPoliza }}
      </p>
    </div>
  </PopupTemplate>
</template>

<script>
/* eslint-disable no-console */
export default {
  props: {
    cuponInic: { type: String, required: true, default: null }
  },

  data() {
    return {
      cupon: this.cuponInic
    };
  },

  created() {
    console.log(this.cuponInic);
  },

  methods: {
    closeCuponAmigoAsignado() {
      this.$emit("closeInfoCuponAmigo");
    }
  }
};
</script>

<style lang="scss">
.cabecera {
  font-size: 120%;
  width: 15rem;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}
</style>
